import ParametrizacaoService from '@/services/ParametrizacaoService';

export const parametrizacao = {
    namespaced: true,
    actions: {
        newParametrizacao(){
            return ParametrizacaoService.newParametrizacao();
        },
        getAllParametrizacao () {
            return ParametrizacaoService.getAllParametrizacao()
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        getParametrizacao ({id}) {
            return ParametrizacaoService.getParametrizacao(id)
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        async getLocalizacaoPadrao () {
            return ParametrizacaoService.getLocalizacaoPadrao()
                .then(
                    response => {
                        return response.data;
                    },
                    error => {
                        console.error(error);
                        return Promise.reject(error);
                    }
                );
        },
        putLocalizacao ({dispatch}, payload) {
            return ParametrizacaoService.putLocalizacao(payload)
            .then(
                response => {
                    return response;
                },
                error => {
                    console.error(error);
                    return Promise.reject(new Error(error));
                }
            );
        },
        postParametrizacao ({payload}) {
            return ParametrizacaoService.postParametrizacao(payload)
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        postParametrizacaoRetornar ({dispatch}, payload) {
            return ParametrizacaoService.postParametrizacaoRetornar(payload)
                .then(
                    response => {
                        return response;
                    },
                    error => {
                        console.error(error);
                    }
                );
        },
        putParametrizacao ({dispatch}, payload) {
            return ParametrizacaoService.putParametrizacao(payload)
            .then(
                response => {
                    return response;
                },
                error => {
                    console.error(error);
                    return Promise.reject(new Error(error));
                }
            );
        },
        deleteParametrizacao ({dispatch}, id) {
            return ParametrizacaoService.deleteParametrizacao(id)
            .then(
                response => {
                    return response;
                },
                error => {
                    console.error(error);
                    return Promise.reject(new Error(error));
                }
            );
        },
        async getRotasPadrao({dispatch, commit}) {
            let rotasCanonicas = sessionStorage.getItem('rotasCanonicas')
            if(rotasCanonicas) {
                commit('rotasObtidasComSucesso', rotasCanonicas)
                return JSON.parse(rotasCanonicas)
            }
            else {
                return ParametrizacaoService.getRotasPadrao()
                    .then(
                        response => {
                            commit('rotasObtidasComSucesso', response.data.rotas)
                            return JSON.parse(response.data.rotas);
                        },
                        error => {
                            console.error(error);
                            return Promise.reject(error);
                        }
                    );
            }
        },
        putRotas ({dispatch}, payload) {
            return ParametrizacaoService.putRotas(payload)
            .then(
                response => {
                    return response;
                },
                error => {
                    console.error(error);
                    return Promise.reject(new Error(error));
                }
            );
        },

        getRotasPadraoManagement() {
            return ParametrizacaoService.getRotasPadrao()
                .then(
                    response => {
                        return  response.data;
                    },
                    error => {
                        console.error(error);
                        return Promise.reject(error);
                    }
                );
        },
    },
    state: {rotas: {}},
    mutations: {
      rotasObtidasComSucesso(state, rotas) {
        sessionStorage.setItem('rotasCanonicas', rotas)
        state.rotas = JSON.parse(rotas)
      }
    },
};
